



























































import { Component, Vue, Ref } from 'vue-property-decorator';

import {
  APPLICATION_USER_DATA,
  CURRENT_UNIT,
} from '@/queries/Application';
import { onUnitChange } from '@/utils/vue-apollo';
import SDropdown from '@/components/UI/SDropdown.vue';
import SAutocomplete from '@/components/UI/Form/Autocomplete/SAutocomplete.vue';
import { GQL_currentUnit_currentUnit } from '../queries/__generated__/currentUnit';
import { GQL_applicationUserData_currentUser } from '../queries/__generated__/applicationUserData';
import { GQL_currentUserUnits_currentUser_units } from '../queries/__generated__/currentUserUnits';
import { SmartQuery } from 'vue-apollo-decorator';
import currentUnitStore from '@/utils/current-unit-store';
import gql from 'graphql-tag';
import RequestAccessToUnit from './RequestAccessToUnit.vue';

const CURRENT_USER_UNITS = gql`
  query currentUserUnits($term: String, $limit: Int, $offset: Int) {
    currentUser {
      id
      units(term: $term, limit: $limit, offset: $offset) {
        id
        name
      }
    }
  }
`;

@Component({
  components: {
    RequestAccessToUnit,
  },
})
export default class ChangeUnit extends Vue {
  @Ref() public readonly dropdown!: SDropdown;
  @Ref() public readonly unitChanger!: SAutocomplete<string, GQL_currentUserUnits_currentUser_units>;

  @SmartQuery(APPLICATION_USER_DATA) public currentUser!: GQL_applicationUserData_currentUser;
  @SmartQuery(CURRENT_UNIT) public currentUnit!: GQL_currentUnit_currentUnit;

  public CURRENT_USER_UNITS = CURRENT_USER_UNITS;
  public showRequestAccessToUnitDialog = false;

  public changeOpen() {
    this.$nextTick(() => {
      this?.unitChanger?.focus();
    });
  }

  public onChangeUnit(unit: {id: string; name: string}) {
    currentUnitStore.set(unit.id);
    currentUnitStore.saveToLocalStorage();
    this.resetStoreAndRedirect();
  }

  private onWindowFocus(): void {
    if (!currentUnitStore.isUpToDate()) {
      currentUnitStore.loadFromLocalStorage();
      this.resetStoreAndRedirect();
    }
  }

  private async resetStoreAndRedirect(): Promise<void> {
    try {
      await this.$router.push({ name: 'BigLoading' });
    } catch (error) {
      if (error.name !== 'NavigationDuplicated') throw error;
    }
    await onUnitChange();
    await this.$router.push({ name: 'Dashboard' });
  }
}
